(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tm-keuzehulp"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tm-keuzehulp')) {
  customElements.define('tm-keuzehulp', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.steps = [...this.querySelectorAll('[data-step]')];
      if (!this.steps.length) return;
      this.current = 0;
      this.querySelector('.tmk-progress').hidden = false;
      this.querySelector('.tmk-actions').hidden = false;
      this.querySelector('.tmk-next').addEventListener('click', () => {
        if (this.validStep(this.current)) this.showStep(this.current + 1, true);
      });
      this.querySelector('.tmk-back').addEventListener('click', () => this.showStep(this.current - 1, true));
      this.form.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT' && this.current < 3) {
          event.preventDefault();
          if (this.validStep(this.current)) this.showStep(this.current + 1, true);
        }
      });
      this.form.addEventListener('invalid', event => {
        const index = this.steps.findIndex(step => step.contains(event.target));
        if (index >= 0 && index !== this.current) this.showStep(index, false);
      }, true);
      this.form.addEventListener('submit', event => {
        for (let index = 0; index < this.steps.length; index++) {
          if (!this.validStep(index)) { event.preventDefault(); return; }
        }
        this.updateAdvice();
      });
      this.showStep(0, false);
    }
    validStep(index) {
      const invalid = [...this.steps[index].querySelectorAll('input,select,textarea')].find(input => !input.validity.valid);
      if (!invalid) return true;
      this.showStep(index, false);
      invalid.reportValidity();
      return false;
    }
    answer(name) {
      return this.querySelector('[data-question="' + name + '"]').selectedOptions[0]?.dataset.code;
    }
    updateAdvice() {
      const product = this.answer('Product');
      const volume = this.answer('Aantal');
      const stage = this.answer('Ontwikkelfase');
      let key = 'review';
      if (product === 'round') key = volume === 'prototype' || stage === 'testing' ? 'review' : 'extrusion';
      if (product === 'part') {
        if (volume === 'prototype' || volume === 'small' || stage === 'testing') key = 'print';
        else if (volume === 'large' && stage === 'ready') key = 'injection';
        else if (volume === 'medium' || volume === 'large') key = 'compare';
      }
      const title = this.querySelector('[data-title="' + key + '"]').textContent;
      let text = this.querySelector('[data-text="' + key + '"]').textContent;
      if (this.answer('Toepassing') === 'special') text += ' ' + this.querySelector('[data-special]').textContent;
      this.querySelector('[data-advice-title]').textContent = title;
      this.querySelector('[data-advice-text]').textContent = text;
      this.querySelector('[data-advice-input]').value = title + ': ' + text;
      this.querySelector('[data-result]').hidden = false;
    }
    showStep(index, focus) {
      this.current = Math.max(0, Math.min(3, index));
      this.steps.forEach((step, i) => { step.hidden = i !== this.current; });
      this.querySelector('progress').value = this.current + 1;
      this.querySelector('[data-step-label]').textContent = this.querySelector('[data-step-pattern]').textContent.replace('[current]', this.current + 1);
      this.querySelector('.tmk-back').hidden = this.current === 0;
      this.querySelector('.tmk-next').hidden = this.current === 3;
      this.querySelector('.tmk-next').textContent = this.querySelector(this.current === 2 ? '[data-show-advice]' : '[data-next-copy]').textContent;
      if (this.current === 3) this.updateAdvice();
      if (focus) this.steps[this.current].querySelector('legend').focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
